import i18next, { type TOptions } from "i18next";

/** Translate copy in pure helpers and lazy catalog getters. React views also
 * subscribe through useTranslation so a language change preserves form state. */
export function t(key: string, options: TOptions = {}): string {
  const translated = i18next.t(key, options);
  if (typeof translated === "string") return translated;
  // Pure helpers may run before the asynchronous catalog has loaded.
  const fallback = typeof options.defaultValue === "string" ? options.defaultValue : key;
  return fallback.replace(/{{\s*([^}\s]+)\s*}}/g, (_, name: string) => String(options[name] ?? ""));
}

let sourceCatalog: unknown;
let sourceKeys = new Map<string, string>();
/** Translate a known interface label while retaining its stable internal value.
 * Use only for product-owned labels, never filenames, project names or prompts. */
export function translateDisplayText(source: string): string {
  const catalog = i18next.getResource?.("en", "translation", "interface") as Record<string, string> | undefined;
  if (catalog !== sourceCatalog) {
    sourceCatalog = catalog;
    sourceKeys = new Map(Object.entries(catalog ?? {}).map(([key, value]) => [value, `interface.${key}`]));
  }
  const key = sourceKeys.get(source);
  return key ? t(key, { defaultValue: source }) : source;
}

/** Active UI locale for dates, numbers and currency; safe before init. */
export function currentLocale(): string {
  return i18next.resolvedLanguage || i18next.language || "en";
}
